import React, { useCallback, useEffect, useState } from 'react'

import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

import Table from '../../../../shared/components/Table/Table.component'

import env from '../../../../networkRequests/apiClient/env.config'
import { getAllFulfillmentOrdersForAdmin } from '../../../../redux/states/admin/orders/getAllFulfillmentOrdersForAdmin/getAllFulfillmentOrdersForAdmin.slice'
import {
  AdminFulfillmentOrderListItem,
  GetAllFulfillmentOrdersForAdminRequestPayload
} from '../../../../redux/states/admin/orders/getAllFulfillmentOrdersForAdmin/getAllFulfillmentOrdersForAdmin.types'
import { RootState } from '../../../../redux/store/store.types'
import { useAppDispatch } from '../../../../shared/hooks/redux.hooks'
import { adminNavigationPaths } from '../../AdminDashboard.dictionary'
import { fulfillmentOrderTableColumns } from './FulfillmentOrders.dictionary'
import styles from './FulfillmentOrders.styles'
import { FulfillmentOrdersProps } from './FulfillmentOrders.types'

const FulfillmentOrders: React.FC<FulfillmentOrdersProps> = (props) => {
  const { searchQuery, demoRouter } = props

  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [fulfillmentOrdersData, setFulfillmentOrdersData] = useState<AdminFulfillmentOrderListItem[]>([])

  const pageSize = env.DEFAULT_PAGE_SIZE
  const dispatch = useAppDispatch()

  const { loading, success, error } = useSelector((state: RootState) => state.getAllFulfillmentOrdersForAdmin)

  useEffect(() => {
    if (success?.data) {
      const { currentPage, totalPages, totalRecords, records } = success.data

      setTotalPages(totalPages)
      setTotalRecords(totalRecords)
      setPage(currentPage)
      setFulfillmentOrdersData(records)
    }
  }, [success])

  const handleGetFulfillmentOrders = useCallback(
    (pageNum: number = 1, size: number = pageSize, onSuccess?: () => void) => {
      const payload: GetAllFulfillmentOrdersForAdminRequestPayload = {
        request: {
          page: pageNum,
          size,
          searchQuery
        },
        onSuccess
      }

      dispatch(getAllFulfillmentOrdersForAdmin(payload))
    },
    [dispatch, searchQuery, pageSize]
  )

  useEffect(() => {
    handleGetFulfillmentOrders()
  }, [handleGetFulfillmentOrders])

  return (
    <Box sx={styles.container}>
      <Table
        columns={fulfillmentOrderTableColumns}
        data={fulfillmentOrdersData}
        pagination={{
          currentPage: page,
          totalPages,
          totalRecords,
          onNext: () => handleGetFulfillmentOrders(page + 1),
          onPrevious: () => handleGetFulfillmentOrders(page - 1)
        }}
        initialLoading={loading}
        error={!!error}
        onRetry={() => handleGetFulfillmentOrders()}
        onRowClick={(_, index) => {
          const orderId = fulfillmentOrdersData[index].orderId
          demoRouter.navigate(`/${adminNavigationPaths.fulfillmentOrders}/${orderId}`)
        }}
        inPage
      />
    </Box>
  )
}

export default FulfillmentOrders
